import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: linear-gradient(135deg, ${props => props.theme.background} 0%, ${props => props.theme.backgroundSecondary} 100%);
  border: 2px solid ${props => props.theme.buttonPrimary};
  border-radius: 12px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  color: ${props => props.theme.text};
  text-align: center;
`;

const ModalTitle = styled.h2`
  margin: 0 0 1rem 0;
  color: ${props => props.theme.success};
  font-size: 1.5rem;
`;

const ModalDescription = styled.p`
  margin: 0 0 2rem 0;
  color: ${props => props.theme.textSecondary};
  line-height: 1.5;
`;

const UpgradeButton = styled.button`
  background: linear-gradient(135deg, #57f287 0%, #4ade80 100%);
  border: none;
  border-radius: 8px;
  color: white;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1rem;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(87, 242, 135, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: ${props => props.theme.textSecondary};
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.25rem;

  &:hover {
    color: ${props => props.theme.text};
  }
`;

const CalendarUpgradePrompt = ({ feature, onUpgrade, onClose }) => {
  const featureMessages = {
    agenda: {
      title: "Unlock Upcoming Deadlines",
      description: "Keep track of your upcoming deadlines with the premium Agenda view. Never miss an important assignment again."
    },
    sidebar: {
      title: "Unlock Upcoming Deadlines",
      description: "Keep track of your upcoming deadlines with the premium sidebar feature. Never miss an important assignment again."
    },
    tooltips: {
      title: "Unlock Assignment Tooltips",
      description: "Hover over assignments to see detailed information including course names, due dates, and completion status with premium tooltips."
    }
  };

  const message = featureMessages[feature] || featureMessages.agenda;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>×</CloseButton>
        <ModalTitle>{message.title}</ModalTitle>
        <ModalDescription>{message.description}</ModalDescription>
        <UpgradeButton onClick={onUpgrade}>Upgrade to Premium</UpgradeButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default CalendarUpgradePrompt;